import axios from 'axios';

export default function (url, type, params) {
  if (!params) params = {};
  let axiosMain;
  if (type.toUpperCase() === 'GET') {
    axiosMain = axios.get(url, {
      params: params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
  } else if (type.toUpperCase() === 'POST') {
    axiosMain = axios.post(url, params, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
  } else if (type.toUpperCase() === 'PUT') {
    let id = params.id;
    delete params['id'];
    axiosMain = axios.put(`${url}/${id}`, params, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
  } else if (type.toUpperCase() === 'PATCH') {
    let id = params.id;
    delete params['id'];
    axiosMain = axios.patch(`${url}/${id}`, params, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
  } else if (type.toUpperCase() === 'DELETE') {
    let id = params.id;
    delete params['id'];
    axiosMain = axios.delete(`${url}/${id}`, {
      params: params,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
  } else if (type.toUpperCase() === 'OPEN') {
    return window.open(`${url}`);
  }
  return axiosMain.then(res => {
    return res.data.response;
  }).catch(err => {
    return err.response.data;
  })

}



// WEBPACK FOOTER //
// ./src/axios/axiosRequire.js